import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

import { coreDataSecurityAccessLogReducers, coreDataSecurityAccessLogWatchers } from './access-log';
import {
	coreDataSecurityAccessStatisticsReducers,
	coreDataSecurityAccessStatisticsWatchers
} from './access-statistics';
import { coreDataSecurityActionPlanReducers, coreDataSecurityActionPlanWatchers } from './action-plan';
import { coreDataSecurityActionTemplatesReducers, coreDataSecurityActionTemplatesWatchers } from './action-templates';
import { coreDataSecurityAlertsReducers, coreDataSecurityAlertsWatchers } from './alerts';
import { coreDataSecurityApiRequestUsageReducers, coreDataSecurityApiRequestUsageWatchers } from './api-request-usage';
import { coreDataSecurityApiVolumeReducers, coreDataSecurityApiVolumeWatchers } from './api-volume';
import {
	coreDataSecurityApplicationOverviewReducers,
	coreDataSecurityApplicationOverviewWatchers
} from './application-overview';
import { coreDataSecurityApplicationsReducers, coreDataSecurityApplicationsWatchers } from './applications';
import { coreDataSecurityAppStatusReducers, coreDataSecurityAppStatusWatchers } from './app-status';
import { coreDataSecurityAppUsersReducers, coreDataSecurityAppUsersWatchers } from './app-users';
import { coreDataSecurityDataAccessReducers, coreDataSecurityDataAccessWatchers } from './data-access';
import {
	coreDataSecurityDetectedApplicationsReducers,
	coreDataSecurityDetectedApplicationsWatchers
} from './detected-applications';
import { coreDataSecurityIncidentLogReducers, coreDataSecurityIncidentLogWatchers } from './incident-log';
import {
	coreDataSecurityMonitoredObjectsReducers,
	coreDataSecurityMonitoredObjectsWatchers
} from './monitored-objects';
import { coreDataSecurityMonitorsReducers, coreDataSecurityMonitorsWatchers } from './monitors';
import { coreDataSecuritySetupAuditTrailReducers, coreDataSecuritySetupAuditTrailWatchers } from './setup-audit-trail';
import { coreDataSecurityStatusReducers, coreDataSecurityStatusWatchers } from './status';
import {
	coreDataSecurityUptimeMonitorsDashboardReducers,
	coreDataSecurityUptimeMonitorsDashboardWatchers
} from './monitors-dashboard';
import { coreDataSecurityUsageReducers, coreDataSecurityUsageWatchers } from './usage';

export const coreDataSecurityReducers = combineReducers({
	accessLog: coreDataSecurityAccessLogReducers,
	accessStatistics: coreDataSecurityAccessStatisticsReducers,
	actionPlan: coreDataSecurityActionPlanReducers,
	actionTemplates: coreDataSecurityActionTemplatesReducers,
	alerts: coreDataSecurityAlertsReducers,
	apiRequestUsage: coreDataSecurityApiRequestUsageReducers,
	apiVolume: coreDataSecurityApiVolumeReducers,
	appStaus: coreDataSecurityAppStatusReducers,
	appUsers: coreDataSecurityAppUsersReducers,
	applicationOverview: coreDataSecurityApplicationOverviewReducers,
	applications: coreDataSecurityApplicationsReducers,
	dataAccess: coreDataSecurityDataAccessReducers,
	detectedApplications: coreDataSecurityDetectedApplicationsReducers,
	incidentLog: coreDataSecurityIncidentLogReducers,
	monitoredObjects: coreDataSecurityMonitoredObjectsReducers,
	monitors: coreDataSecurityMonitorsReducers,
	monitorsDashboard: coreDataSecurityUptimeMonitorsDashboardReducers,
	setupAuditTrail: coreDataSecuritySetupAuditTrailReducers,
	status: coreDataSecurityStatusReducers,
	usage: coreDataSecurityUsageReducers
});

export const coreDataSecurityWatchers = combineAllWatchers([
	coreDataSecurityAccessLogWatchers,
	coreDataSecurityAccessStatisticsWatchers,
	coreDataSecurityActionPlanWatchers,
	coreDataSecurityActionTemplatesWatchers,
	coreDataSecurityAlertsWatchers,
	coreDataSecurityApiRequestUsageWatchers,
	coreDataSecurityApiVolumeWatchers,
	coreDataSecurityAppStatusWatchers,
	coreDataSecurityAppUsersWatchers,
	coreDataSecurityApplicationOverviewWatchers,
	coreDataSecurityApplicationsWatchers,
	coreDataSecurityMonitorsWatchers,
	coreDataSecurityDataAccessWatchers,
	coreDataSecurityDetectedApplicationsWatchers,
	coreDataSecurityIncidentLogWatchers,
	coreDataSecurityMonitoredObjectsWatchers,
	coreDataSecuritySetupAuditTrailWatchers,
	coreDataSecurityStatusWatchers,
	coreDataSecurityUptimeMonitorsDashboardWatchers,
	coreDataSecurityUsageWatchers
]);
